export default "__VITE_PUBLIC_ASSET__2f0ffa6e__"